import React, {Component} from 'react';
import {
    Card,
    CardHeader,
    CardText
} from 'material-ui/Card';
import Chip from 'material-ui/Chip';
import './timeline.css';

class TimelineComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
          expanded1: false,
          expanded2: false,
          expanded3: false
        };
    }

    async componentDidMount() {}

    componentWillUnmount() {}

    handleExpandChange = (expanded1) => {
      this.setState({expanded1: expanded1});
    };

    handleExpandChange2 = (expanded2) => {
      this.setState({expanded2: expanded2});
    };

    handleExpandChange3 = (expanded3) => {
      this.setState({expanded3: expanded3});
    };

    handleExpand = () => {
      this.setState({expanded: true});
    };

    handleExpand2 = () => {
      this.setState({expanded2: true});
    };

    handleExpand3 = () => {
      this.setState({expanded3: true});
    };

    handleReduce = () => {
      this.setState({expanded1: false});
    };

    handleReduce2 = () => {
      this.setState({expanded2: false});
    };

    handleReduce3 = () => {
      this.setState({expanded3: false});
    };
    render() {
        return (
            <div className="timeline">
              <p className="headline">Projects</p>
                <div className="timeline-entry">
                  <Card>
                      <CardHeader title="DSL 810: Data Driven Science" subtitle="Prof. Jay Dhariwal"actAsExpander={true} showExpandableButton={true}/>
                      <CardText expandable={true}>
                          Data Driven Science : Applied Design process in finding solutions to Social Problems
                          <br/><br/>
                            <div className="timeline-entries">
                              <div className="timeline-entry-chip">
                                <Chip>Web-Development</Chip>
                              </div>
                              <div className="timeline-entry-chip">
                                <Chip>Machine Learning</Chip>
                              </div>
                              <div className="timeline-entry-chip">
                                <Chip>Python</Chip>
                              </div>
                              <div className="timeline-entry-chip">
                                <Chip>MATLAB</Chip>
                              </div>
                              <div className="timeline-entry-chip">
                                <Chip>Video Editing</Chip>
                              </div>
                              <div className="timeline-entry-chip">
                                <Chip>Data Preprocessing</Chip>
                              </div>
                              <div className="timeline-entry-chip">
                                <Chip>Data Collections</Chip>
                              </div>
                            </div>
                      </CardText>
                  </Card>
                </div>
                  <div className="timeline-entry">
                    <Card expanded={this.state.expanded1} onExpandChange={this.handleExpandChange}>
                        <CardHeader title="Asynchronous Video Interviewing " subtitle="Computer Vision Project"
                          actAsExpander={true} showExpandableButton={true}/>
                        <CardText expandable={true}>
                            Project Info Will be available Soon
                            <br/><br/>
                              <div className="timeline-entries">
                                <div className="timeline-entry-chip">
                                  <Chip>Deep Learning</Chip>  
                                </div>
                                <div className="timeline-entry-chip">
                                  <Chip>Computer Vision</Chip>
                                </div>
                                <div className="timeline-entry-chip">
                                  <Chip>Tensorflow</Chip>
                                </div>
                                <div className="timeline-entry-chip">
                                  <Chip>Data Augmentation</Chip>
                                </div>
                                <div className="timeline-entry-chip">
                                  <Chip>Collaborative Work</Chip>
                                </div>
                              </div>
                        </CardText>
                    </Card>
                  </div>
                  <div className="timeline-entry">
                  <Card expanded={this.state.expanded2} onExpandChange={this.handleExpandChange2}>
                      <CardHeader title="iShare-IIT" subtitle="Web Development Project "
                        actAsExpander={true} showExpandableButton={true}/>
                      <CardText expandable={true}>
                          A site to share your Gadgets with your College Mates. Visit <a href="https://ishare1.herokuapp.com">iShareIIT</a> 

                          <div className="timeline-entries">
                            <div className="timeline-entry-chip">
                              <Chip>Django</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>MongoDB</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>Python</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>HTML-CSS3</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>Heroku</Chip>
                            </div>
                          </div>
                      </CardText>
                  </Card>
                </div>
                <div className="timeline-entry">
                  <Card expanded={this.state.expanded3} onExpandChange={this.handleExpandChange3}>
                      <CardHeader title="UX Research Project" subtitle="Redesigned Whatsapp"
                        actAsExpander={true} showExpandableButton={true}/>
                      <CardText expandable={true}>
                          Project Info Will be made available soon

                          <div className="timeline-entries">
                            <div className="timeline-entry-chip">
                              <Chip>UX Design Process</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>UX Research </Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>Figma</Chip>
                            </div>
                          </div>
                      </CardText>
                  </Card>
                </div>
            </div>
        );
    }
}

export default TimelineComponent;



// WEBPACK FOOTER //
// ./src/components/timeline/timeline.jsx